import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import { moduleConfig } from './config';
import {
  buildListQuery,
  ListQueryOptions,
  normalizePaginatedListResponse,
  PaginatedApiResponse,
} from '../../../services/paginatedList';

type CodeName = { id: number; code?: string | null; name?: string | null };

export interface PmsComponent {
  id: number;
  systemId: number;
  criticalityId: number;
  recordStatusId: number;
  parentComponentId?: number | null;
  code: string;
  name: string;
  description?: string | null;
  manufacturer?: string | null;
  model?: string | null;
  isActive?: boolean;
  system?: CodeName | null;
  criticality?: CodeName | null;
  recordStatus?: CodeName | null;
  parentComponent?: CodeName | null;
  createdAt?: string;
  updatedAt?: string;
  [key: string]: unknown;
}

export const usePmsComponents = (
  searchParams?: string,
  page = 1,
  limit = 25,
  options?: ListQueryOptions,
) => {
  const q = buildListQuery(searchParams, page, limit, options);
  const { data, error, isLoading, mutate } = useSWR<
    PaginatedApiResponse<PmsComponent> | PmsComponent[]
  >(`${moduleConfig.module.api.list}${q}`, fetcher, { revalidateOnFocus: true });
  const normalized = normalizePaginatedListResponse<PmsComponent>(data, page, limit);
  return {
    data: normalized.data,
    clients: normalized.data,
    total: normalized.total,
    page: normalized.page,
    limit: normalized.limit,
    isLoading,
    isError: error,
    mutate,
  };
};

export const usePmsComponent = (id?: number) => {
  const { data, error, isLoading, mutate } = useSWR<PmsComponent>(
    id != null && Number.isFinite(id) && id > 0 ? moduleConfig.module.api.detail(id) : null,
    fetcher,
    { revalidateOnFocus: true },
  );
  return { data, item: data, isLoading, isError: error, mutate };
};
